import React from 'react'
import './Datatable.css'

export interface Column<T> {
  header: string
  accessor: keyof T | ((row: T) => React.ReactNode)
  className?: string
}

interface DataTableProps<T> {
  columns: Column<T>[]
  data: T[]
  rowKey: (row: T) => React.Key
}

export function DataTable<T>({ columns, data, rowKey }: DataTableProps<T>) {
  return (
    <table className="data-table">
      <thead>
        <tr>
          {columns.map((col, i) => (
            <th key={i} className={col.className || ''}>
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={rowKey(row)}>
            {columns.map((col, i) => {
              const cell =
                typeof col.accessor === 'function'
                  ? col.accessor(row)
                  : (row[col.accessor] as any)
              return (
                <td className={col.className} key={i}>
                  {cell}
                </td>
              )
            })}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
